import {
  GET_COMPONENT_LIST_BY_COMPANY_ID,
  GET_MASTER_COMPONENT_LIST,
  SET_STAKEHOLDER_COMPONENT
} from "../constants/index";

const initialValue = {
  componentListData: [],
  specificComponentData: "",
  defaultComponentList: [],
  stakeholderComponents: []
};

const manageComponent = (state = initialValue, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_COMPONENT_LIST_BY_COMPANY_ID: {
      return {
        ...state,
        componentListData: payload,
      };
    }

    case GET_MASTER_COMPONENT_LIST: {
      return {
        ...state,
        defaultComponentList: payload
      }
    }

    case SET_STAKEHOLDER_COMPONENT: {
      return {
        ...state,
        stakeholderComponents: payload
      }
    }

    default:
      return state;
  }
};

export default manageComponent;
